import { axiosApi } from '@/axios'
import { Paginator, Params, Services } from '@/utils/interfaces'
import { AxiosResponse } from 'axios'

export function getServices(
  params?: Params,
): Promise<AxiosResponse<Paginator<Services>>> {
  return axiosApi.get('/services/', { params })
}
